/* eslint-disable */
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, {
    useState,
  } from "react";
  import "./style.css";
  import { useSelector } from "react-redux";
  import { useDispatch } from "react-redux";
  import {
    pauseTimer,
    resumeTimer,
    setTimerFullscreen,
    tmpStopTimer,
  } from "../../redux/slices/timer";
  import {
    focusTimerFormatV2,
    focusTimerFormatV3,
    hexToRgb,
    planTimeFormat,
  } from "../action/utilities";
  import { useNavigate } from "react-router-dom";
import { MaximizeIcon, PauseIcon, PlayIcon, StopIcon } from "../LandingHeader/Feedback/icons/Icons";
import moment from "moment";
import { decodeToken } from "react-jwt";
import { useSocket } from "../../SocketContext";

function RunningFocusTimerV2({ defaultMaximizTimer = false, focusMode = false, display = true }) {
  const navigate = useNavigate();
  const [collapse, setCollapse] = useState(false);
  const focusTimer = useSelector((state) => state.focusTimer);
  const {
    timer,
    currentTimer,
    additionalTimer,
    activeTimer,
    focusSessions
  } = focusTimer;
  const [time, setTime] = useState(currentTimer);
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme.theme);
  const {socket} = useSocket();

  const pauseAction = (e) => {
      e.preventDefault();
      dispatch(pauseTimer('FocusModePause'));
      triggerWebSocket({ action: "focusModePause" })
  }

  const resumeAction = (e) => {
      e.preventDefault();
      dispatch(resumeTimer('focusMode'));
      triggerWebSocket({ action: "resumeTimer" })
  }

  const stop = (e) => {
      e.preventDefault();
      dispatch(tmpStopTimer());
      triggerWebSocket({ action: "tmpStopTimer" })
      navigate('/focus-mode-completed');
  }

  const maximize = (e) => {
      e.preventDefault();
      dispatch(setTimerFullscreen(true));
      triggerWebSocket({ action: "fullscreen", fullscreenValue: true })
  }

  const triggerWebSocket = (data) => {
    // Trigger timer in wepapp and other clients
    if (socket !== null){
        const user = decodeToken(localStorage.getItem('token'));
        socket.emit('focusTimer', {room: user['outseta:accountUid'], data});
    }
  }

  return (
      <div
      className={`dailyQuote focus-timer running ${theme ?? ""}`}
      style={{
        boxShadow:
          theme == "dark" && defaultMaximizTimer
            ? `0px 4px 250px ${hexToRgb('var(--accent-color)')}`
            : "none",
      }}
    >
      <div
        className={`quoteHeader ${collapse ? "head-option focusRunning" : ""} `}
        style={{
          background:
            theme == "dark"
              ? "linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), #000000"
              : activeTimer == "focus"
              ? "#F2F2F2"
              : "#F2F2F2",
          position: "relative",
          overflow: "hidden",
        }}
        onClick={() => setCollapse(!collapse)}
      >
        {collapse === true && (
          <span
            className="running-timer-collapse"
            dangerouslySetInnerHTML={{
              __html: planTimeFormat(
                time + additionalTimer,
                theme == "dark" ? "#fff" : "#000"
              ),
            }}
          ></span>
        )}
        
      </div>
      {collapse === false && (
        <div
          className={`quoteContainer focus-timer-widget bg-white dark:bg-black focus-timer-container border-2 border-white dark:border-black focusMode`}
          css={{
              '&:before' : {
                  background: `linear-gradient(180deg, rgba(39, 203, 154, 0) 0%, var(--accent-color) 100%), linear-gradient(180deg, rgba(var(--theme-mode-rgb-white-reverse), 0) 0%, rgba(var(--theme-mode-rgb-white-reverse), 0.2) 100%)`,
                  width: `${100 - (currentTimer * 100) / timer}% !important`
              }
          }}
        >
          <div className="focused-items-heading text-black dark:text-white">
                  Focus Session {focusSessions.filter(session => moment().format('L') === moment(session.startTime).format('L')).length}
              </div>
              <div id="focus-timer-bar" className={theme} style={{background: 'none', backdropFilter: 'none'}}>
                  <div className='timer-calc'>
                      <div className='timer-calc-display text-black/80 dark:text-white/80'>
                          <span className="accent-text-color" dangerouslySetInnerHTML={{ __html: `${focusTimerFormatV3(currentTimer, true)} left...` }} />
                          <span className="text-black/50 dark:text-white/50" dangerouslySetInnerHTML={{ __html: `/ ${focusTimerFormatV2(timer)}` }} />
                      </div>
                  </div>
                  <div className='timer-actions'>
                      <a href="#" onClick={stop} className='end-session tooltip-link text-black dark:text-white' css={{
                          '&:after': {
                              background: `var(--accent-color) !important`
                          }
                      }}>
                          <StopIcon />
                          <span className="tooltip-hover"></span>
                          <span 
                              className="block-on-hover text-gray-100 dark:text-white">
                              Stop
                          </span>
                      </a>
                      {
                          activeTimer === 'focusMode'
                          ?
                          <a href="#" className="tooltip-link" onClick={pauseAction}>
                              <PauseIcon opacity={theme === 'dark' ? 0.5 : 1} />
                              <span className="tooltip-hover"></span>
                              <span 
                                  className="block-on-hover text-gray-100 dark:text-white">
                                  Pause
                              </span>
                          </a>
                          :
                          <a href="#" className="tooltip-link" onClick={resumeAction}>
                              <PlayIcon fill={`var(--accent-color)`} color={`var(--accent-color)`} />
                              <span className="tooltip-hover"></span>
                              <span 
                                  className="block-on-hover text-gray-100 dark:text-white">
                                  Resume
                              </span>
                          </a>
                      }
                      <a href="#" className="tooltip-link" onClick={maximize}>
                          <MaximizeIcon />
                          <span className="tooltip-hover"></span>
                          <span 
                              className="block-on-hover text-gray-100 dark:text-white"
                              css={{
                                  left: '-130% !important',
                              }}>
                              Maximise
                          </span>
                      </a>
                  </div>
              </div>
        </div>
      )}
    </div>
  );
}

export default RunningFocusTimerV2;